import React from "react";
import { Route } from "react-router-dom";

import {QNAUIProvider} from "../../contexts/QNAUIContext";
import {QNAContainer} from '../../components/containers/QNAContainer';
import {QNADetailModal} from '../../components/modules/QNADetailModal';

import {URLs} from "../../../utils/routes";

export function QNAPage({ history }) {
  const QNAUIEvents = {
    openQNADetailDialog: (id) => {
      history.push(`${URLs.CS_QNA}/${id}`);
    },
  };

  return (
    <>
      <QNAUIProvider QNAUIEvents={QNAUIEvents}>
        <QNAContainer />
      </QNAUIProvider>

      <Route path={URLs.CS_QNA_DETAIL}>
        {({ history, match }) => match ? (
          <QNADetailModal
            show={true}
            key={match.params.qnaId}
            qnaId={match.params.qnaId}
            onHide={() => history.goBack()}
          />
        ) : null}
      </Route>
    </>
  );
}

